export default __webpack_public_path__ + "static/media/hearthstone.4fc4352e.png";